<template>
    <div>
        <template v-if="corporate_transaction_in === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <div class="page-top float-left">
                    <h1 class="m-0">Account Balance: <span class="highlight-color"> (PKR {{formatAmount(account_balance)}})</span> </h1>
                </div>
            </div>
            <div class="corporate-main">
                <div class="corporate-head pb-3 clearfix">
                    <h3 class="transaction-history-head float-left">Transfer In</h3>
                </div>
                <form @submit.prevent="transferInAmount">
                    <div class="corporate-content mt-5 pt-5 pb-5">
                        <h4 class="mb-3"> <span class="title"> Account </span> {{customer_name}} Bank Account {{payment_instrument_bank_account_number}} </h4>
                        <div class="form-group mb-3">
                            <input v-model="form.amount" v-on:keydown="onlyNumber" type="text" name="amount" class="form-control" :class="{ 'is-invalid': form.errors.has('amount') }" placeholder="Enter Amount">
                            <has-error :form="form" field="amount"></has-error>
                        </div>
                        <button :disabled="form.busy" class="btn btn-primary active"> Transfer in </button>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="corporate_transaction_in === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="corporate_transaction_in === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    amount : '',
                }),
                account_balance: null,
                customer_name: null,
                payment_instrument_bank_account_number: null,
                corporate_transaction_in: null
            };
        },
        methods: {
            transferInAmount(){
                this.$Progress.start();
                this.form.post("/api/transferIn")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.account_balance = res.data.accountDetail.balance;
                            this.showToastBox('success',res.data.msg);
                        }else{
                            this.showToastBox('error',res.data.msg);
                        }
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            }
        },
        mounted() {
			this.can('corporate_transaction_in').then(result => {
                axios.get("/api/checkSessionData")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 201){
                            this.$router.push('/corporateLogin');
                        }else{
                            this.account_balance = res.data.accountDetail.balance;
                            this.customer_name = res.data.accountDetail.customerName;
                            this.payment_instrument_bank_account_number = res.data.accountDetail.paymentInstrumentBankAccountNumber;
                            this.corporate_transaction_in = result.corporate_transaction_in;
                        }
                    }else{
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            });

        },
    }
</script>
